module.exports = __webpack_public_path__ + "static/mobilePricing-1d3775c9c524400ebba133ebbca0bfce.png";